import Toast from '@/utils/toast'
import { decorateActivityTitles } from '@/utils/limitedActivity'
// axios拦截设置
import { AJAX_BASE_URL, getKey, IS_MINIPROGRAM, IS_WEIXIN, isYQQF, preview, siteConfig } from '@/config'
import axios from 'axios'
import { Base64 } from 'js-base64'
import { Indicator } from 'mint-ui'
import { Confirm } from '../components/'
import Router from '../router/index'
import Cookie from '@/plugins/cookie'

const {
  interfaceEncryption = false,
  isLogicDot = false,
  meituanFlag = false,
  meituanCard = false,
  useWeixinOpenIdLogin = false,
  useMiniProgramLogin = false
} = siteConfig
const encodeString = (str) => {
  return str.slice(0, 1) + Math.random().toString().split('.')[1].slice(0, 3) + str.slice(1)
}
const decodeString = (str) => {
  return str.slice(0, 1) + str.slice(4)
}

if (preview.inIframe || process.env.NODE_ENV === 'development') {
  axios.defaults.headers.common['real-url'] = AJAX_BASE_URL
  axios.defaults.baseURL = location.origin + '/proxy-forward'
} else {
  axios.defaults.baseURL = AJAX_BASE_URL
}
axios.interceptors.request.use((config) => {
  if (process.env.NODE_ENV === 'development') {
    config.withCredentials = true
  }
  config.params = config.params || {}
  if (!window.cookieEnabled) {
    const address = Cookie.get('address')
    const op = ['goodsPool', 'goods_list', 'get_goods_ById', 'store_goods', 'channelRecommendGoods']
    if (address && op.includes(config.params.op)) {
      config.params.customAddress = address
    }
  }

  if (config.addTime !== false) {
    config.params['_t'] = Date.now()
  }
  if (meituanFlag) {
    config.headers.common.token = localStorage.getItem(window._cookiePath + 'key') || ''
  }
  // 用户token
  if (!config.params.key && !['goods_list', 'store_goods'].includes(config.params.op)) {
    config.params.key = getKey()
  }
  // encrypt_store_id
  if (isYQQF) {
    config.params.encrypt_store_id = window._config.path.replace(/\//g, '')
  }
  // 逻辑积分
  if (isLogicDot) {
    config.params.logicdot = 1
  }
  // 参数加密
  if (interfaceEncryption) {
    const temp = {}
    // get加密参数
    for (let key in config.params) {
      if (config.params[key]) {
        temp[key] = encodeString(Base64.encode(encodeURIComponent(config.params[key])))
      }
    }
    config.params = temp
    // post加密参数
    if (config.data) {
      for (let key of config.data) {
        config.data.set(key[0], encodeString(Base64.encode(encodeURIComponent(key[1]))))
      }
    }
  }

  if (meituanCard) {
    const { act, op = 'index' } = config.params
    delete config.params.act
    delete config.params.op
    config.url = AJAX_BASE_URL.split('index.php')[0] + `${act}/${op}`
  }

  const source = axios.CancelToken.source()
  const previousToken = config.cancelToken
  const adapter = config.adapter || axios.defaults.adapter
  let finished = false
  const entry = {
    cancel: () => {
      if (finished) return
      source.cancel('route_change')
      finish()
    }
  }
  const finish = () => {
    if (finished) return
    finished = true
    window.__axiosPromiseArr = (window.__axiosPromiseArr || []).filter((item) => item !== entry)
    axios.xhrNum = Math.max(0, (axios.xhrNum || 0) - 1)
    if (axios.xhrNum === 0) Indicator.close()
  }
  config.cancelToken = source.token
  config._finishRequest = finish
  if (previousToken) {
    previousToken.promise.then((reason) => {
      if (!finished) {
        source.cancel(reason && reason.message)
        finish()
      }
    })
  }
  // 序列化可能在进入 adapter 前抛错，也必须释放请求状态。
  const transforms = typeof config.transformRequest === 'function'
    ? [config.transformRequest] : Object.values(config.transformRequest || {})
  config.transformRequest = transforms.map((transform) => function (data, headers) {
    try {
      return transform.call(this, data, headers)
    } catch (error) {
      finish()
      throw error
    }
  })
  // adapter 层覆盖没有 config 的取消异常；响应拦截器覆盖请求分发异常。
  config.adapter = (requestConfig) => Promise.resolve()
    .then(() => {
      source.token.throwIfRequested()
      return adapter(requestConfig)
    })
    .then((response) => {
      finish()
      return response
    }, (error) => {
      finish()
      return Promise.reject(error)
    })
  window.__axiosPromiseArr = window.__axiosPromiseArr || []
  window.__axiosPromiseArr.push(entry)
  axios.xhrNum = (axios.xhrNum || 0) + 1
  if (config.loading !== false) Indicator.open({ spinnerType: 'double-bounce' })

  return config
})

axios.interceptors.response.use(
  (response) => {
    if (response.config._finishRequest) response.config._finishRequest()
    const data = response.data
    // 解密结果
    if (interfaceEncryption) {
      data.datas = JSON.parse(Base64.decode(decodeString(data.datas)))
      if (process.env.NODE_ENV !== 'production' && !['pack_coupon_list', 'redeem_pack_coupon'].includes(response.config.params?.op)) {
        console.log(data)
      }
    }
    if (data.code === 200) {
      decorateActivityTitles(data.datas, meituanCard)
      return data
    }
    const { showMessage = true, showLoginForm = true } = response.config || {}
    if (data.code === 400 && showMessage) {
      // 需要登录，先不做处理
      if (data.login * 1 === 0) {
        if (showLoginForm) {
          // 立即跳转
          if (data.jumpImmediately) {
            if (sessionStorage.getItem('dispatchLoginPath') === Router.currentRoute.path) {
              Router.back()
              sessionStorage.removeItem('dispatchLoginPath')
              return
            }
            if (window._thirdLoginMethods) {
              sessionStorage.setItem('dispatchLoginPath', Router.currentRoute.path)
              window._thirdLoginMethods()
            } else {
              Router.push({ path: '/login' }).then()
            }
            return
          }
          Confirm({
            title: '提示',
            message: '您还没有登录，点击确认去登录！',
            callback(res) {
              if (res === 'confirm') {
                if (window._thirdLoginMethods) {
                  window._thirdLoginMethods()
                } else if (useWeixinOpenIdLogin && IS_WEIXIN && !IS_MINIPROGRAM) { // 微信公众号授权登录
                  window.location.href = AJAX_BASE_URL + '?act=wxlogin&op=subscription'
                } else if (useMiniProgramLogin && IS_MINIPROGRAM) { // 微信小程序授权登录
                  window.wx?.miniProgram.navigateTo({
                    url: '/pages/login/login'
                  })
                } else {
                  Router.push({ path: '/login' }).then()
                }
              }
            }
          })
        }
      } else {
        const {
          datas: { error },
          showError = true
        } = data
        if (error && error !== '提交数据错误' && showError) {
          Toast({
            message: error,
            position: 'bottom'
          })
        }
      }
    }
    return Promise.reject(data)
  },
  (error) => {
    if (error && error.config && error.config._finishRequest) error.config._finishRequest()
    if (!axios.isCancel(error) && error && error.config?.showMessage !== false && error.message && /[\u4e00-\u9fa5]+/.test(error.message)) {
      Toast({
        message: error.message,
        position: 'bottom'
      })
    }
    return Promise.reject(error)
  }
)

export { axios }

export default {
  install(Vue) {
    Vue.prototype.$http = axios
  }
}
